import { render, staticRenderFns } from "./RegularHoursTab.vue?vue&type=template&id=48f043cd&scoped=true"
import script from "./RegularHoursTab.vue?vue&type=script&lang=js"
export * from "./RegularHoursTab.vue?vue&type=script&lang=js"
import style0 from "./RegularHoursTab.vue?vue&type=style&index=0&id=48f043cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f043cd",
  null
  
)

export default component.exports